import React from "react"

import ApplicationStepper from "@/components/application/ApplicationStepper"
import OrientationQuiz from "@/components/application/OrientationQuiz"
import AppLayout from "@/components/layout/AppLayout"

const OrientationQuizPage = () => {
  return (
    <AppLayout>
      <div className="container mx-auto px-4 pb-8 md:px-8">
        <ApplicationStepper />

        <h1 className="mb-2 text-center text-2xl font-bold text-jungle md:text-2xl">
          Orientation Quiz
        </h1>
        <p className="mb-8 text-center text-gray-600">
          Test your understanding of our procedures and guidelines
        </p>

        <div className="mx-auto max-w-2xl">
          <OrientationQuiz />
        </div>
      </div>
    </AppLayout>
  )
}

export default OrientationQuizPage
